
import React from 'react';

import { ReactComponent as Policy } from '../assets/icons/Policy.svg';
import { ReactComponent as Terms } from '../assets/icons/Terms.svg';
import { ReactComponent as about_b } from '../assets/icons/about_b.svg';
import { ReactComponent as about_big } from '../assets/icons/about_big.svg';
import { ReactComponent as account } from '../assets/icons/account.svg';
import { ReactComponent as add } from '../assets/icons/add.svg';
import { ReactComponent as add_project } from '../assets/icons/add_project.svg';
import { ReactComponent as alarmz_icn } from '../assets/icons/alarmz_icn.svg';
import { ReactComponent as analytics } from '../assets/icons/analytics.svg';
import { ReactComponent as analytics_bb } from '../assets/icons/analytics_bb.svg';
import { ReactComponent as android } from '../assets/icons/android.svg';
import { ReactComponent as android_fill } from '../assets/icons/android_fill.svg';
import { ReactComponent as angellist } from '../assets/icons/angellist.svg';
import { ReactComponent as apple } from '../assets/icons/apple.svg';
import { ReactComponent as apple_fill } from '../assets/icons/apple_fill.svg';
import { ReactComponent as apple_music } from '../assets/icons/apple_music.svg';
import { ReactComponent as archive } from '../assets/icons/archive.svg';
import { ReactComponent as attach } from '../assets/icons/attach.svg';
import { ReactComponent as back } from '../assets/icons/back.svg';
import { ReactComponent as bag } from '../assets/icons/bag.svg';
import { ReactComponent as bandcamp } from '../assets/icons/bandcamp.svg';
import { ReactComponent as behance_line } from '../assets/icons/behance_line.svg';
import { ReactComponent as blocked } from '../assets/icons/blocked.svg';
import { ReactComponent as blog } from '../assets/icons/blog.svg';
import { ReactComponent as blog_line } from '../assets/icons/blog_line.svg';
import { ReactComponent as bluesky } from '../assets/icons/bluesky.svg';
import { ReactComponent as bold } from '../assets/icons/bold.svg';
import { ReactComponent as bookmark } from '../assets/icons/bookmark.svg';
import { ReactComponent as bookmark_line } from '../assets/icons/bookmark_line.svg';
import { ReactComponent as bookmark_off } from '../assets/icons/bookmark_off.svg';
import { ReactComponent as bookmark_on } from '../assets/icons/bookmark_on.svg';
import { ReactComponent as broken_link } from '../assets/icons/broken_link.svg';
import { ReactComponent as browser } from '../assets/icons/browser.svg';
import { ReactComponent as btn_bg } from '../assets/icons/btn_bg.svg';
import { ReactComponent as btn_bg_hover } from '../assets/icons/btn_bg_hover.svg';
import { ReactComponent as button } from '../assets/icons/button.svg';
import { ReactComponent as buymeacoffee } from '../assets/icons/buymeacoffee.svg';
import { ReactComponent as cal } from '../assets/icons/cal.svg';
import { ReactComponent as cal2 } from '../assets/icons/cal2.svg';
import { ReactComponent as camera } from '../assets/icons/camera.svg';
import { ReactComponent as canva } from '../assets/icons/canva.svg';
import { ReactComponent as cards } from '../assets/icons/cards.svg';
import { ReactComponent as cart } from '../assets/icons/cart.svg';
import { ReactComponent as caution } from '../assets/icons/caution.svg';
import { ReactComponent as chat } from '../assets/icons/chat.svg';
import { ReactComponent as check_on } from '../assets/icons/check_on.svg';
import { ReactComponent as chrome } from '../assets/icons/chrome.svg';
import { ReactComponent as clear } from '../assets/icons/clear.svg';
import { ReactComponent as clear_ani } from '../assets/icons/clear_ani.svg';
import { ReactComponent as close } from '../assets/icons/close.svg';
import { ReactComponent as close_s } from '../assets/icons/close_s.svg';
import { ReactComponent as clubhouse } from '../assets/icons/clubhouse.svg';
import { ReactComponent as codepen } from '../assets/icons/codepen.svg';
import { ReactComponent as company } from '../assets/icons/company.svg';
import { ReactComponent as company_ani } from '../assets/icons/company_ani.svg';
import { ReactComponent as delete_account } from '../assets/icons/delete_account.svg';
import { ReactComponent as delete_icn } from '../assets/icons/delete_icn.svg';
import { ReactComponent as designer } from '../assets/icons/designer.svg';
import { ReactComponent as designer_ani } from '../assets/icons/designer_ani.svg';
import { ReactComponent as deviantart } from '../assets/icons/deviantart.svg';
import { ReactComponent as discord } from '../assets/icons/discord.svg';
import { ReactComponent as dots_off } from '../assets/icons/dots_off.svg';
import { ReactComponent as dots_on } from '../assets/icons/dots_on.svg';
import { ReactComponent as download } from '../assets/icons/download.svg';
import { ReactComponent as dribbble_line } from '../assets/icons/dribbble_line.svg';
import { ReactComponent as drop } from '../assets/icons/drop.svg';
import { ReactComponent as drop_down } from '../assets/icons/drop_down.svg';
import { ReactComponent as drop_up } from '../assets/icons/drop_up.svg';
import { ReactComponent as edge } from '../assets/icons/edge.svg';
import { ReactComponent as edit } from '../assets/icons/edit.svg';
import { ReactComponent as edit_ani } from '../assets/icons/edit_ani.svg';
import { ReactComponent as employer } from '../assets/icons/employer.svg';
import { ReactComponent as empty } from '../assets/icons/empty.svg';
import { ReactComponent as empty_on } from '../assets/icons/empty_on.svg';
import { ReactComponent as en } from '../assets/icons/en.svg';
import { ReactComponent as error } from '../assets/icons/error.svg';
import { ReactComponent as etsy } from '../assets/icons/etsy.svg';
import { ReactComponent as event_line } from '../assets/icons/event_line.svg';
import { ReactComponent as experience } from '../assets/icons/experience.svg';
import { ReactComponent as eye_off } from '../assets/icons/eye_off.svg';
import { ReactComponent as eye_on } from '../assets/icons/eye_on.svg';
import { ReactComponent as facebook_line } from '../assets/icons/facebook_line.svg';
import { ReactComponent as fav } from '../assets/icons/fav.svg';
import { ReactComponent as fav_click } from '../assets/icons/fav_click.svg';
import { ReactComponent as fav_non } from '../assets/icons/fav_non.svg';
import { ReactComponent as fav_on } from '../assets/icons/fav_on.svg';
import { ReactComponent as figma_line } from '../assets/icons/figma_line.svg';
import { ReactComponent as firefox } from '../assets/icons/firefox.svg';
import { ReactComponent as flag } from '../assets/icons/flag.svg';
import { ReactComponent as focus_icn } from '../assets/icons/focus_icn.svg';
import { ReactComponent as ghost } from '../assets/icons/ghost.svg';
import { ReactComponent as github } from '../assets/icons/github.svg';
import { ReactComponent as gitlab } from '../assets/icons/gitlab.svg';
import { ReactComponent as global } from '../assets/icons/global.svg';
import { ReactComponent as globe } from '../assets/icons/globe.svg';
import { ReactComponent as gmail } from '../assets/icons/gmail.svg';
import { ReactComponent as gumroad } from '../assets/icons/gumroad.svg';
import { ReactComponent as hand1 } from '../assets/icons/hand1.svg';
import { ReactComponent as hand2 } from '../assets/icons/hand2.svg';
import { ReactComponent as hand3 } from '../assets/icons/hand3.svg';
import { ReactComponent as hand4 } from '../assets/icons/hand4.svg';
import { ReactComponent as heart } from '../assets/icons/heart.svg';
import { ReactComponent as home } from '../assets/icons/home.svg';
import { ReactComponent as horror } from '../assets/icons/horror.svg';
import { ReactComponent as hum } from '../assets/icons/hum.svg';
import { ReactComponent as hum2 } from '../assets/icons/hum2.svg';
import { ReactComponent as human } from '../assets/icons/human.svg';
import { ReactComponent as humb } from '../assets/icons/humb.svg';
import { ReactComponent as icon00 } from '../assets/icons/icon00.svg';
import { ReactComponent as icon01 } from '../assets/icons/icon01.svg';
import { ReactComponent as icon02 } from '../assets/icons/icon02.svg';
import { ReactComponent as icon03 } from '../assets/icons/icon03.svg';
import { ReactComponent as icon04 } from '../assets/icons/icon04.svg';
import { ReactComponent as icon05 } from '../assets/icons/icon05.svg';
import { ReactComponent as icon06 } from '../assets/icons/icon06.svg';
import { ReactComponent as icon07 } from '../assets/icons/icon07.svg';
import { ReactComponent as id } from '../assets/icons/id.svg';
import { ReactComponent as id_1 } from '../assets/icons/id_1.svg';
import { ReactComponent as image } from '../assets/icons/image.svg';
import { ReactComponent as images } from '../assets/icons/images.svg';
import { ReactComponent as instagram_line } from '../assets/icons/instagram_line.svg';
import { ReactComponent as invitation } from '../assets/icons/invitation.svg';
import { ReactComponent as italic } from '../assets/icons/italic.svg';
import { ReactComponent as item_name } from '../assets/icons/item_name.svg';
import { ReactComponent as job } from '../assets/icons/job.svg';
import { ReactComponent as jobs_ani } from '../assets/icons/jobs_ani.svg';
import { ReactComponent as juusando_text } from '../assets/icons/juusando_text.svg';
import { ReactComponent as kik } from '../assets/icons/kik.svg';
import { ReactComponent as language } from '../assets/icons/language.svg';
import { ReactComponent as left_arrow } from '../assets/icons/left_arrow.svg';
import { ReactComponent as like } from '../assets/icons/like.svg';
import { ReactComponent as line } from '../assets/icons/line.svg';
import { ReactComponent as link } from '../assets/icons/link.svg';
import { ReactComponent as link_ext } from '../assets/icons/link_ext.svg';
import { ReactComponent as linkedin_line } from '../assets/icons/linkedin_line.svg';
import { ReactComponent as linux } from '../assets/icons/linux.svg';
import { ReactComponent as list } from '../assets/icons/list.svg';
import { ReactComponent as list_number } from '../assets/icons/list_number.svg';
import { ReactComponent as load } from '../assets/icons/load.svg';
import { ReactComponent as loading } from '../assets/icons/loading.svg';
import { ReactComponent as loading_ } from '../assets/icons/loading_.svg';
import { ReactComponent as loading_ani } from '../assets/icons/loading_ani.svg';
import { ReactComponent as lock } from '../assets/icons/lock.svg';
import { ReactComponent as login } from '../assets/icons/login.svg';
import { ReactComponent as logoo } from '../assets/icons/logoo.svg';
import { ReactComponent as logout } from '../assets/icons/logout.svg';
import { ReactComponent as mail } from '../assets/icons/mail.svg';
import { ReactComponent as mail2 } from '../assets/icons/mail2.svg';
import { ReactComponent as mail_ani } from '../assets/icons/mail_ani.svg';
import { ReactComponent as map } from '../assets/icons/map.svg';
import { ReactComponent as mastodon } from '../assets/icons/mastodon.svg';
import { ReactComponent as medium } from '../assets/icons/medium.svg';
import { ReactComponent as meetup } from '../assets/icons/meetup.svg';
import { ReactComponent as message_back } from '../assets/icons/message_back.svg';
import { ReactComponent as messenger } from '../assets/icons/messenger.svg';
import { ReactComponent as mic } from '../assets/icons/mic.svg';
import { ReactComponent as mobile } from '../assets/icons/mobile.svg';
import { ReactComponent as money } from '../assets/icons/money.svg';
import { ReactComponent as mute_off } from '../assets/icons/mute_off.svg';
import { ReactComponent as mute_on } from '../assets/icons/mute_on.svg';
import { ReactComponent as name_card } from '../assets/icons/name_card.svg';
import { ReactComponent as namecard } from '../assets/icons/namecard.svg';
import { ReactComponent as namecard_2 } from '../assets/icons/namecard_2.svg';
import { ReactComponent as new_mail } from '../assets/icons/new_mail.svg';
import { ReactComponent as new_password } from '../assets/icons/new_password.svg';
import { ReactComponent as news } from '../assets/icons/news.svg';
import { ReactComponent as newsletter } from '../assets/icons/newsletter.svg';
import { ReactComponent as norif_off } from '../assets/icons/norif_off.svg';
import { ReactComponent as norif_on } from '../assets/icons/norif_on.svg';
import { ReactComponent as notion } from '../assets/icons/notion.svg';
import { ReactComponent as ok } from '../assets/icons/ok.svg';
import { ReactComponent as opera } from '../assets/icons/opera.svg';
import { ReactComponent as order_az } from '../assets/icons/order_az.svg';
import { ReactComponent as order_za } from '../assets/icons/order_za.svg';
import { ReactComponent as page } from '../assets/icons/page.svg';
import { ReactComponent as password } from '../assets/icons/password.svg';
import { ReactComponent as patreon } from '../assets/icons/patreon.svg';
import { ReactComponent as pause } from '../assets/icons/pause.svg';
import { ReactComponent as phone } from '../assets/icons/phone.svg';
import { ReactComponent as pin } from '../assets/icons/pin.svg';
import { ReactComponent as pinjob } from '../assets/icons/pinjob.svg';
import { ReactComponent as pinjob_ani } from '../assets/icons/pinjob_ani.svg';
import { ReactComponent as pinterest } from '../assets/icons/pinterest.svg';
import { ReactComponent as popup } from '../assets/icons/popup.svg';
import { ReactComponent as portfolio } from '../assets/icons/portfolio.svg';
import { ReactComponent as poshmark } from '../assets/icons/poshmark.svg';
import { ReactComponent as post } from '../assets/icons/post.svg';
import { ReactComponent as press_kit } from '../assets/icons/press_kit.svg';
import { ReactComponent as privacy } from '../assets/icons/privacy.svg';
import { ReactComponent as producthunt } from '../assets/icons/producthunt.svg';
import { ReactComponent as project } from '../assets/icons/project.svg';
import { ReactComponent as pull_down } from '../assets/icons/pull_down.svg';
import { ReactComponent as pull_up } from '../assets/icons/pull_up.svg';
import { ReactComponent as px500 } from '../assets/icons/px500.svg';
import { ReactComponent as qibla_icn } from '../assets/icons/qibla_icn.svg';
import { ReactComponent as radio_off } from '../assets/icons/radio_off.svg';
import { ReactComponent as reddit } from '../assets/icons/reddit.svg';
import { ReactComponent as register } from '../assets/icons/register.svg';
import { ReactComponent as report } from '../assets/icons/report.svg';
import { ReactComponent as reqest } from '../assets/icons/reqest.svg';
import { ReactComponent as reset } from '../assets/icons/reset.svg';
import { ReactComponent as restart } from '../assets/icons/restart.svg';
import { ReactComponent as right_arrow } from '../assets/icons/right_arrow.svg';
import { ReactComponent as right_arrow_ani } from '../assets/icons/right_arrow_ani.svg';
import { ReactComponent as robot } from '../assets/icons/robot.svg';
import { ReactComponent as safari } from '../assets/icons/safari.svg';
import { ReactComponent as save } from '../assets/icons/save.svg';
import { ReactComponent as screen } from '../assets/icons/screen.svg';
import { ReactComponent as search } from '../assets/icons/search.svg';
import { ReactComponent as search_ani } from '../assets/icons/search_ani.svg';
import { ReactComponent as send } from '../assets/icons/send.svg';
import { ReactComponent as send_ani } from '../assets/icons/send_ani.svg';
import { ReactComponent as services } from '../assets/icons/services.svg';
import { ReactComponent as setting } from '../assets/icons/setting.svg';
import { ReactComponent as shake_hands } from '../assets/icons/shake_hands.svg';
import { ReactComponent as signal } from '../assets/icons/signal.svg';
import { ReactComponent as signup } from '../assets/icons/signup.svg';
import { ReactComponent as skyki_icn } from '../assets/icons/skyki_icn.svg';
import { ReactComponent as small_arrow } from '../assets/icons/small_arrow.svg';
import { ReactComponent as snapchat } from '../assets/icons/snapchat.svg';
import { ReactComponent as social } from '../assets/icons/social.svg';
import { ReactComponent as soundcloud } from '../assets/icons/soundcloud.svg';
import { ReactComponent as spotify } from '../assets/icons/spotify.svg';
import { ReactComponent as stackoverflow } from '../assets/icons/stackoverflow.svg';
import { ReactComponent as stop } from '../assets/icons/stop.svg';
import { ReactComponent as subject } from '../assets/icons/subject.svg';
import { ReactComponent as substack } from '../assets/icons/substack.svg';
import { ReactComponent as tag } from '../assets/icons/tag.svg';
import { ReactComponent as telegram } from '../assets/icons/telegram.svg';
import { ReactComponent as text_small } from '../assets/icons/text_small.svg';
import { ReactComponent as threads_line } from '../assets/icons/threads_line.svg';
import { ReactComponent as tiktok_line } from '../assets/icons/tiktok_line.svg';
import { ReactComponent as timer } from '../assets/icons/timer.svg';
import { ReactComponent as timez_icn } from '../assets/icons/timez_icn.svg';
import { ReactComponent as todo_icn } from '../assets/icons/todo_icn.svg';
import { ReactComponent as trash } from '../assets/icons/trash.svg';
import { ReactComponent as trash_ani } from '../assets/icons/trash_ani.svg';
import { ReactComponent as twetter_line } from '../assets/icons/twetter_line.svg';
import { ReactComponent as twitch } from '../assets/icons/twitch.svg';
import { ReactComponent as twitter_line } from '../assets/icons/twitter_line.svg';
import { ReactComponent as twtter_line } from '../assets/icons/twtter_line.svg';
import { ReactComponent as u99_icn } from '../assets/icons/u99_icn.svg';
import { ReactComponent as unarchive } from '../assets/icons/unarchive.svg';
import { ReactComponent as unpin } from '../assets/icons/unpin.svg';
import { ReactComponent as upload } from '../assets/icons/upload.svg';
import { ReactComponent as user } from '../assets/icons/user.svg';
import { ReactComponent as user_2 } from '../assets/icons/user_2.svg';
import { ReactComponent as user_bb } from '../assets/icons/user_bb.svg';
import { ReactComponent as user_circle } from '../assets/icons/user_circle.svg';
import { ReactComponent as user_page } from '../assets/icons/user_page.svg';
import { ReactComponent as username } from '../assets/icons/username.svg';
import { ReactComponent as users } from '../assets/icons/users.svg';
import { ReactComponent as uud } from '../assets/icons/uud.svg';
import { ReactComponent as uud1 } from '../assets/icons/uud1.svg';
import { ReactComponent as uud4 } from '../assets/icons/uud4.svg';
import { ReactComponent as uud_icon } from '../assets/icons/uud_icon.svg';
import { ReactComponent as uud_icon2 } from '../assets/icons/uud_icon2.svg';
import { ReactComponent as uud_line } from '../assets/icons/uud_line.svg';
import { ReactComponent as uud_logo } from '../assets/icons/uud_logo.svg';
import { ReactComponent as uud_sns } from '../assets/icons/uud_sns.svg';
import { ReactComponent as uxer_2_on } from '../assets/icons/uxer_2_on.svg';
import { ReactComponent as uxer_simple } from '../assets/icons/uxer_simple.svg';
import { ReactComponent as view } from '../assets/icons/view.svg';
import { ReactComponent as view_link } from '../assets/icons/view_link.svg';
import { ReactComponent as views } from '../assets/icons/views.svg';
import { ReactComponent as vk } from '../assets/icons/vk.svg';
import { ReactComponent as web_line } from '../assets/icons/web_line.svg';
import { ReactComponent as wechat } from '../assets/icons/wechat.svg';
import { ReactComponent as whatsapp } from '../assets/icons/whatsapp.svg';
import { ReactComponent as windows } from '../assets/icons/windows.svg';
import { ReactComponent as windows_fill } from '../assets/icons/windows_fill.svg';
import { ReactComponent as youtube_line } from '../assets/icons/youtube_line.svg';
import { ReactComponent as zilapp } from '../assets/icons/zilapp.svg';
import { ReactComponent as zilapp_01 } from '../assets/icons/zilapp_01.svg';
import { ReactComponent as zilapp_02 } from '../assets/icons/zilapp_02.svg';
import { ReactComponent as zilapp_03 } from '../assets/icons/zilapp_03.svg';
import { ReactComponent as zilapp_icn } from '../assets/icons/zilapp_icn.svg';
import { ReactComponent as zilapp_letter } from '../assets/icons/zilapp_letter.svg';
import { ReactComponent as zilapp_line } from '../assets/icons/zilapp_line.svg';
import { ReactComponent as zilapp_logo } from '../assets/icons/zilapp_logo.svg';

const iconComponents = {
  'Policy': Policy,
  'Terms': Terms,
  'about_b': about_b,
  'about_big': about_big,
  'account': account,
  'add': add,
  'add_project': add_project,
  'alarmz_icn': alarmz_icn,
  'analytics': analytics,
  'analytics_bb': analytics_bb,
  'android': android,
  'android_fill': android_fill,
  'angellist': angellist,
  'apple': apple,
  'apple_fill': apple_fill,
  'apple_music': apple_music,
  'archive': archive,
  'attach': attach,
  'back': back,
  'bag': bag,
  'bandcamp': bandcamp,
  'behance_line': behance_line,
  'blocked': blocked,
  'blog': blog,
  'blog_line': blog_line,
  'bluesky': bluesky,
  'bold': bold,
  'bookmark': bookmark,
  'bookmark_line': bookmark_line,
  'bookmark_off': bookmark_off,
  'bookmark_on': bookmark_on,
  'broken_link': broken_link,
  'browser': browser,
  'btn_bg': btn_bg,
  'btn_bg_hover': btn_bg_hover,
  'button': button,
  'buymeacoffee': buymeacoffee,
  'cal': cal,
  'cal2': cal2,
  'camera': camera,
  'canva': canva,
  'cards': cards,
  'cart': cart,
  'caution': caution,
  'chat': chat,
  'check_on': check_on,
  'chrome': chrome,
  'clear': clear,
  'clear_ani': clear_ani,
  'close': close,
  'close_s': close_s,
  'clubhouse': clubhouse,
  'codepen': codepen,
  'company': company,
  'company_ani': company_ani,
  'delete_account': delete_account,
  'delete_icn': delete_icn,
  'designer': designer,
  'designer_ani': designer_ani,
  'deviantart': deviantart,
  'discord': discord,
  'dots_off': dots_off,
  'dots_on': dots_on,
  'download': download,
  'dribbble_line': dribbble_line,
  'drop': drop,
  'drop_down': drop_down,
  'drop_up': drop_up,
  'edge': edge,
  'edit': edit,
  'edit_ani': edit_ani,
  'employer': employer,
  'empty': empty,
  'empty_on': empty_on,
  'en': en,
  'error': error,
  'etsy': etsy,
  'event_line': event_line,
  'experience': experience,
  'eye_off': eye_off,
  'eye_on': eye_on,
  'facebook_line': facebook_line,
  'fav': fav,
  'fav_click': fav_click,
  'fav_non': fav_non,
  'fav_on': fav_on,
  'figma_line': figma_line,
  'firefox': firefox,
  'flag': flag,
  'focus_icn': focus_icn,
  'ghost': ghost,
  'github': github,
  'gitlab': gitlab,
  'global': global,
  'globe': globe,
  'gmail': gmail,
  'gumroad': gumroad,
  'hand1': hand1,
  'hand2': hand2,
  'hand3': hand3,
  'hand4': hand4,
  'heart': heart,
  'home': home,
  'horror': horror,
  'hum': hum,
  'hum2': hum2,
  'human': human,
  'humb': humb,
  'icon00': icon00,
  'icon01': icon01,
  'icon02': icon02,
  'icon03': icon03,
  'icon04': icon04,
  'icon05': icon05,
  'icon06': icon06,
  'icon07': icon07,
  'id': id,
  'id_1': id_1,
  'image': image,
  'images': images,
  'instagram_line': instagram_line,
  'invitation': invitation,
  'italic': italic,
  'item_name': item_name,
  'job': job,
  'jobs_ani': jobs_ani,
  'juusando_text': juusando_text,
  'kik': kik,
  'language': language,
  'left_arrow': left_arrow,
  'like': like,
  'line': line,
  'link': link,
  'link_ext': link_ext,
  'linkedin_line': linkedin_line,
  'linux': linux,
  'list': list,
  'list_number': list_number,
  'load': load,
  'loading': loading,
  'loading_': loading_,
  'loading_ani': loading_ani,
  'lock': lock,
  'login': login,
  'logoo': logoo,
  'logout': logout,
  'mail': mail,
  'mail2': mail2,
  'mail_ani': mail_ani,
  'map': map,
  'mastodon': mastodon,
  'medium': medium,
  'meetup': meetup,
  'message_back': message_back,
  'messenger': messenger,
  'mic': mic,
  'mobile': mobile,
  'money': money,
  'mute_off': mute_off,
  'mute_on': mute_on,
  'name_card': name_card,
  'namecard': namecard,
  'namecard_2': namecard_2,
  'new_mail': new_mail,
  'new_password': new_password,
  'news': news,
  'newsletter': newsletter,
  'norif_off': norif_off,
  'norif_on': norif_on,
  'notion': notion,
  'ok': ok,
  'opera': opera,
  'order_az': order_az,
  'order_za': order_za,
  'page': page,
  'password': password,
  'patreon': patreon,
  'pause': pause,
  'phone': phone,
  'pin': pin,
  'pinjob': pinjob,
  'pinjob_ani': pinjob_ani,
  'pinterest': pinterest,
  'popup': popup,
  'portfolio': portfolio,
  'poshmark': poshmark,
  'post': post,
  'press_kit': press_kit,
  'privacy': privacy,
  'producthunt': producthunt,
  'project': project,
  'pull_down': pull_down,
  'pull_up': pull_up,
  'px500': px500,
  'qibla_icn': qibla_icn,
  'radio_off': radio_off,
  'reddit': reddit,
  'register': register,
  'report': report,
  'reqest': reqest,
  'reset': reset,
  'restart': restart,
  'right_arrow': right_arrow,
  'right_arrow_ani': right_arrow_ani,
  'robot': robot,
  'safari': safari,
  'save': save,
  'screen': screen,
  'search': search,
  'search_ani': search_ani,
  'send': send,
  'send_ani': send_ani,
  'services': services,
  'setting': setting,
  'shake_hands': shake_hands,
  'signal': signal,
  'signup': signup,
  'skyki_icn': skyki_icn,
  'small_arrow': small_arrow,
  'snapchat': snapchat,
  'social': social,
  'soundcloud': soundcloud,
  'spotify': spotify,
  'stackoverflow': stackoverflow,
  'stop': stop,
  'subject': subject,
  'substack': substack,
  'tag': tag,
  'telegram': telegram,
  'text_small': text_small,
  'threads_line': threads_line,
  'tiktok_line': tiktok_line,
  'timer': timer,
  'timez_icn': timez_icn,
  'todo_icn': todo_icn,
  'trash': trash,
  'trash_ani': trash_ani,
  'twetter_line': twetter_line,
  'twitch': twitch,
  'twitter_line': twitter_line,
  'twtter_line': twtter_line,
  'u99_icn': u99_icn,
  'unarchive': unarchive,
  'unpin': unpin,
  'upload': upload,
  'user': user,
  'user_2': user_2,
  'user_bb': user_bb,
  'user_circle': user_circle,
  'user_page': user_page,
  'username': username,
  'users': users,
  'uud': uud,
  'uud1': uud1,
  'uud4': uud4,
  'uud_icon': uud_icon,
  'uud_icon2': uud_icon2,
  'uud_line': uud_line,
  'uud_logo': uud_logo,
  'uud_sns': uud_sns,
  'uxer_2_on': uxer_2_on,
  'uxer_simple': uxer_simple,
  'view': view,
  'view_link': view_link,
  'views': views,
  'vk': vk,
  'web_line': web_line,
  'wechat': wechat,
  'whatsapp': whatsapp,
  'windows': windows,
  'windows_fill': windows_fill,
  'youtube_line': youtube_line,
  'zilapp': zilapp,
  'zilapp_01': zilapp_01,
  'zilapp_02': zilapp_02,
  'zilapp_03': zilapp_03,
  'zilapp_icn': zilapp_icn,
  'zilapp_letter': zilapp_letter,
  'zilapp_line': zilapp_line,
  'zilapp_logo': zilapp_logo,
};

const SvgIcn = ({ Name, ...props }) => {
  const SelectedIcon = iconComponents[Name];
  if (!SelectedIcon) {
    console.warn(`Icon "${Name}" not found`);
    return null; // Or a default icon
  }

  return <SelectedIcon {...props} />;
};

export default SvgIcn;
